export const isLoading = state => state.loadingProcesses > 0
export const images = state => state.images
export const autoScroll = state => state.autoScroll
export const scrollSpeed = state => state.scrollSpeed
export const buttons = state => state.buttons